<div class="flex justify-center">
<div class="flex w-[80vw]  mt-10 text-sm text-gray-800 ">
  <div class="space-y-3 w-[30%]">
    <div *ngIf="indexDocumentInfo() as calcSponsor">
      <p class="font-semibold">Index Calculation Agent</p>
      <ng-container *ngIf="isValueNameBnpParibas(calcSponsor.calculationSponsor?.IndexCalculationName) ; else showCalcImage">
        <p>BNP Paribas Arbitrage SNC</p>
      </ng-container>
      <ng-template #showCalcImage>
        <img
          src="{{ deployUrlHost }}/assets/{{calcSponsor.calculationSponsor?.IndexCalculationPath}}"
          alt="BNP Paribas Logo"
          class="h-8 sm:h-12 md:h-16 lg:h-20 w-auto"
        />
      </ng-template>
    </div>
    <div *ngIf="indexDocumentInfo() as calcSponsor">
      <p class="font-semibold mt-4">Index Sponsor</p>

      <!-- 1️⃣ Special case – same rule for the sponsor name -->
      <ng-container *ngIf="isValueNameBnpParibas(calcSponsor.calculationSponsor?.IndexSponsorName) ; else showSponsorImage">
        <p>BNP Paribas SA</p>
      </ng-container>

      <!-- 2️⃣ Default case – sponsor logo -->
      <ng-template #showSponsorImage>
        <img
          src="{{ deployUrlHost }}/assets/{{calcSponsor.calculationSponsor?.IndexSponsorPath}}"
          alt="BNP Paribas Sponsor Logo"
          class="h-8 sm:h-12 md:h-16 lg:h-20 w-auto"
        />
      </ng-template>
    </div>
  </div>
  <div class="space-y-3 w-[40%]">
    <div>
      <p class="font-semibold pl-6 pb-2">Documentation</p>
      <ul class="flex flex-col gap-2">
        <li class="flex w-[100%]" *ngFor="let item of indexDocumentInfo()?.documents">
          <div class="flex-1">
            <div class="font-medium">{{item.Title}}</div>
            <div>{{item.FormattedPublicationDate}}</div>
          </div>
          <a href="javascript:void(0)" >
            <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
            <img width="25px"
                 height="29px"
                 [src]="item.FileExtension === 'XLSX'
                 ? deployUrlHost + '/assets/XLS_icon.png'
                 : deployUrlHost + '/assets/PDF_icon.png'"
                 [alt]="item.FileExtension === 'XLSX' ? 'XLS icon' : 'PDF icon'"
                 (click)="onDownloadDocument(item)">
          </a>
        </li>
        <li class="flex w-[100%]">
          <div class="flex-1">
            <div>Indicators definition</div>
            <div>{{ todayFormatted }}</div>
          </div>
          <a href="{{ deployUrlHost }}/assets/pdf/IndicatorsDefinition.pdf">
            <img width="25px" height="29px" src="{{ deployUrlHost }}/assets/PDF_icon.png"
                 alt="">
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
</div>
<div class="border-t-4 border-green-700 my-8 w-full"></div>
<div class="flex justify-center">
<div class="mt-5 w-[80vw]" *ngIf="indexKeyInfo()">
  <h3 class="text-lg font-bold text-gray-800  mb-2">Disclaimer</h3>
  <div [innerHTML]="fullDisclaimer()" class="disclaimer-text text-sm leading-relaxed text-gray-800 list-disc pl-4"></div>
</div>
</div>
